/* マイページサブスクリプション詳細文字列書き換え */
if (window.location.pathname.startsWith('/apps/floor-s')) {
  const observer = new MutationObserver((mutations) => {
    document.querySelectorAll('p.chakra-text.css-0').forEach((el) => {
      if (el.textContent.includes('配送予定日')) {
        el.textContent = 'お届け予定日';
      }
      if (el.textContent.includes('配送時間帯')) {
        el.textContent = 'お届け時間帯';
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}